var styleDataHash = "6b575428";
const injectCss = (() => {
  var css = `.DFDbC{margin-left:0;margin-right:auto;z-index:1}.DFDbC:not(.oBjMy){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.DFDbC:not(.oBjMy){float:none;margin-right:auto}}}@container (width < 480px){.DFDbC:not(.oBjMy){float:none;margin-right:auto}}.LQh-P{margin-left:auto;margin-right:0;z-index:1}.LQh-P:not(.oBjMy){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.LQh-P:not(.oBjMy){float:none;margin-left:auto}}}@container (width < 480px){.LQh-P:not(.oBjMy){float:none;margin-left:auto}}.kSezv{clear:both;display:block}.kSezv:not(.Ok19v){margin-left:auto;margin-right:auto;max-width:100%}.Ok19v,.oBjMy{width:100%}.pg6HC .Ok19v,.pg6HC .oBjMy{margin:0 -8px;width:auto}.gMjb9{width:fit-content}.u1i0j{margin-left:auto;margin-right:auto;max-width:100%}._6QmtR{width:min(350px,100%)!important}.pg6HC ._6QmtR{width:50%}._2is25{margin-left:auto;margin-right:auto}.pg6HC ._2is25{width:150px}.k0WHV{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "DFDbC",
  "textWrapNowrap": "oBjMy",
  "alignRight": "LQh-P",
  "alignCenter": "kSezv",
  "sizeFullWidth": "Ok19v",
  "renderedInTable": "pg6HC",
  "sizeOriginal": "gMjb9",
  "sizeContent": "u1i0j",
  "sizeSmall": "_6QmtR",
  "sizeSmallCenter": "_2is25",
  "flex": "k0WHV"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
